<ng-container *transloco="let t">
  @if (productStatus) {
    @if (productStatus === ShortageStatus.Available) {
      {{ t(ShortageStatusNames.Available) }}
    }

    @if (productStatus === ShortageStatus.BackInStock) {
      {{ t(ShortageStatusNames.BackInStock) }}
    }

    @if (productStatus === ShortageStatus.Shortage) {
      {{ t(ShortageStatusNames.Shortage) }}
    }

    @if (productStatus === ShortageStatus.OutOfTrade) {
      {{ t(ShortageStatusNames.OutOfTrade) }}
    }

    @if (productStatus === ShortageStatus.AvailableAtWholesaler) {
      {{ t(ShortageStatusNames.AvailableAtWholesaler) }}
    }

    @if (productStatus === ShortageStatus.PreferableThroughWholesaler) {
      {{ t(ShortageStatusNames.PreferableThroughWholesaler) }}
    }

    @if (productStatus === ShortageStatus.Limited) {
      {{ t(ShortageStatusNames.Limited) }}
    }

    @if (productStatus === ShortageStatus.Pruning) {
      {{ t(ShortageStatusNames.Pruning) }}
    }
  }
</ng-container>
